<template>
  <WdsLabel
    v-if="shouldDisplay"
    v-bind="$attrs"
    subtle
    :warning="state.warning"
    :success="state.success"
    :error="state.error"
    :primary="state.primary"
  >
    {{ $t(label) }}
  </WdsLabel>
</template>

<script setup lang="ts">
import { WdsLabel } from '@worksome/wds-components'
import { computed } from 'vue'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { ContactStatus } from '@/gql/graphql'

const props = defineProps<{ status: ContactStatus }>()

const labelInfo = computed(() => {
  switch (props.status) {
    case ContactStatus.Invited:
      return { label: 'Invite pending', state: { warning: true } }
    case ContactStatus.Applied:
      return { label: 'Applied', state: { primary: true } }
    case ContactStatus.Active:
      return { label: 'Active', state: { success: true } }
    case ContactStatus.Blocked:
      return { label: 'Blocked', state: { error: true } }
    case ContactStatus.Declined:
      return { label: 'Declined', state: { error: true } }
    default:
      return { label: '', state: { primary: true } }
  }
})

const label = computed(() => labelInfo.value.label)
const state = computed(() => labelInfo.value.state)

const shouldDisplay = computed(() => ['Invite pending', 'Applied'].includes(label.value))
</script>
